import { render, staticRenderFns } from "./screenFinal3round2.vue?vue&type=template&id=f9ad4bdc&scoped=true"
import script from "./screenFinal3round2.vue?vue&type=script&lang=js"
export * from "./screenFinal3round2.vue?vue&type=script&lang=js"
import style0 from "./screenFinal3round2.vue?vue&type=style&index=0&id=f9ad4bdc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ad4bdc",
  null
  
)

export default component.exports